import { useQuery } from 'react-query';
import apiClient from '../request/http-common';

export const useJointAccountBalance = () => {
  return useQuery(
    'jointAccountBalance',
    async () => {
      try {
        const response = await apiClient.get('/api/joint-accounts');
        const jointAccounts = response.data.joint_accounts || [];
        
        // Calculate total balance from all joint accounts user is a member of
        const totalBalance = jointAccounts.reduce((total, account) => {
          return total + (parseFloat(account.balance) || 0);
        }, 0);
        
        return {
          totalBalance,
          accountCount: jointAccounts.length,
          accounts: jointAccounts
        };
      } catch (error) {
        console.error('Error fetching joint account balance:', error);
        return {
          totalBalance: 0,
          accountCount: 0,
          accounts: []
        };
      }
    },
    {
      staleTime: 30000, // 30 seconds
      refetchInterval: 60000, // Refetch every minute
      retry: 2
    }
  );
}; 